import { render } from "./OperationExam.vue?vue&type=template&id=b0610c8e&scoped=true"
import script from "./OperationExam.vue?vue&type=script&lang=js"
export * from "./OperationExam.vue?vue&type=script&lang=js"

import "./OperationExam.vue?vue&type=style&index=0&id=b0610c8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0610c8e"]])

export default __exports__